import { logToSentry } from "utils/networkErrorUtils";
import { apis } from 'utils/lib/apis';
import * as StudentGroup from "./actions";

/**
 * Creates a new student group with the provided payload data and updates the store with the new group data.
 * @async
 * @param {Object} payload - The data for the new student group to be created.
 * @returns {Promise<Object>} A promise that resolves to the created student group data.
 * @throws Will capture and log any error that is not a "Network Error".
 */

export const handleCreateStudentGroup = (payload,userId) => async (dispatch) => {
  try {
    const data = await apis.post("studentGroup", `/create`, {
      body: payload,
    });
    if (payload?.id?.length > 0) {
      await dispatch(StudentGroup.updateGroupData(data));
    } else {
      await dispatch(StudentGroup.setStudentGroupData(data));
    }
    if (userId) {
      await dispatch(handleGetStudentGroup(userId))
    }
    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'STUDENT_GROUP',
                operation: 'CREATE_STUDENT_GROUP'
            });
    }
  }
};

/**
 * Gets all student groups for a teacher, and sets the student group data in the store
 * @param {number} id - The ID of the teacher
 * @returns {Promise} A promise that resolves to the student group data
 */
export const handleGetStudentGroup = (id) => async (dispatch) => {
  try {
    const data = await apis.post("studentGroup", `/list?created_by=${id}`);
    if (data) {
      await dispatch(StudentGroup.updateStudentGroup({teacherData: data}));
    }
    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'STUDENT_GROUP',
                operation: 'GET_STUDENT_GROUP'
            });
    }
  }
};

/**
 * Gets all student groups for a teacher, and sets the student group data in the store
 * @param {number} id - The ID of the teacher
 * @returns {Promise} A promise that resolves to the student group data
 */
export const handleDelteStudentGroup = (id) => async (dispatch) => {
  try {
    const data = await apis.del("studentGroup", `/delete/${id}`);
    if (data) {
      await dispatch(StudentGroup.DeleteStudentGroupData(id));
    }
    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'STUDENT_GROUP',
                operation: 'DELTE_STUDENT_GROUP'
            });
    }
  }
};

export const handleListByClassId = (id) => async (dispatch) => {
  try {
    const data = await apis.post(
      "studentGroup",
      `/listByClassId?class_id=${id}`
    );
    if (data) {
      await dispatch(StudentGroup.setClassIdByData(data));
    }
    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'STUDENT_GROUP',
                operation: 'LIST_BY_CLASS_ID'
            });
    }
  }
};
